import { useCallback } from "react";
import { default as WaveSurferRef } from "wavesurfer.js";

interface useHandleWaveSurferMount {
  currentTrack: React.MutableRefObject<WaveSurferRef | null>;
  fileVersionId?: number;
  source: string;
  onReady?: (duration: number) => void;
  waveformPeaks?: string;
  duration?: number;
  setupEvents?: (wavesurferRef: WaveSurferRef | null) => void;
}

export const useHandleWaveSurferMount = ({
  currentTrack,
  fileVersionId,
  source,
  onReady,
  waveformPeaks,
  duration,
  setupEvents,
}: useHandleWaveSurferMount) => {
  return useCallback(
    async (waveSurfer: WaveSurferRef | null) => {
      if (waveSurfer === null) return;
      currentTrack.current = waveSurfer;
      if (!waveformPeaks || !duration) {
        void currentTrack.current?.load(source).catch(() => {});
      }
      if (window && fileVersionId) {
        if (!window.surferidze) {
          window.surferidze = {};
        }
        window.surferidze[fileVersionId] = currentTrack.current;
      }
      currentTrack.current?.on("error", () => {});
      currentTrack.current?.on("destroy", () => {
        currentTrack.current?.unAll();
        currentTrack.current?.destroy();
      });
      if (setupEvents) {
        setupEvents(waveSurfer);
        return;
      }
      currentTrack.current?.once("ready", (duration: number) => {
        currentTrack.current?.setVolume(0);
        if (onReady) {
          onReady(duration);
          return;
        }
      });
    },
    [
      currentTrack,
      duration,
      fileVersionId,
      onReady,
      setupEvents,
      source,
      waveformPeaks,
    ],
  );
};
